import { createGlobalStyle } from "styled-components";

export const GlobalDisableCopyPaste = createGlobalStyle`
    [data-disable-copy-paste] {
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
`;

const DESKTOP_MIN_WIDTH = "1024px";
const HALF_CARD_DESKTOP_MAX_WIDTH = "700px";

export const GlobalDesktopHalfCardStyles = createGlobalStyle`
    @media (min-width: ${DESKTOP_MIN_WIDTH}) {
        [role="dialog"][aria-modal].open,
        [role="dialog"][aria-modal].close {
            left: 50%;
            right: auto;
            max-width: ${HALF_CARD_DESKTOP_MAX_WIDTH};
            width: 100%;
            margin-left: calc(-${HALF_CARD_DESKTOP_MAX_WIDTH} / 2);
        }
    }
`;
